import { safeGet } from '../../utils/safeGet'

let requesting = false

/**
 * 检查用户是否拥有此权限
 * @param {object} store - Vuex store
 * @param {string} perm - Permission needs to check
 * @param {string} dataPath - Data path in store
 * @param {string} actionName - Load permission async
 * @param {object} actionParams - Load permission async
 * @returns {boolean} - Whether logged user has this permission
*/
export const checkPerm = function (store, perm, dataPath = 'perm.api_perms', actionName = 'loadUserPerms', actionParmas = {}) {
  let list = safeGet(store.state, dataPath)
  let result = false
  if (!Array.isArray(list)) {
    async function load() {
      await store.dispatch(actionName, actionParmas)
      requesting = false
      list = safeGet(store.state, dataPath) || []
      result = list.includes(perm)
    }
    if (!requesting) {
      requesting = !requesting
      load()
    }
    return result
  } else {
    return list.includes(perm)
  }
}

export default class UserPerms {
  constructor(operations) {
    this.state = {}

    this.mutations = {
      setUserPerms(state, data) {
        Object.keys(data).forEach(item => {
          state[item] = data[item]
        })
      }
    }

    this.actions = {
      async loadUserPerms({ commit }, parmas) {
        const resp = await operations.getPerms(parmas)
        commit('setUserPerms', resp.data)
        return resp.data
      }
    }
  }
}



// WEBPACK FOOTER //
// ./packages/helper/permission/index.js